/* eslint-disable no-unused-vars */
import axios from 'axios';

const localURL = 'http://localhost:9000/fireswan-pro/us-central1/api';
const sandURL = 'https://us-central1-fireswan-pro.cloudfunctions.net/api';
const prodURL = 'https://us-central1-fireswan-production.cloudfunctions.net/api';

export default axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? prodURL : '',
});
